import classes from './CustomOverlayPanel.module.scss'
import { OverlayPanel } from 'primereact/overlaypanel'

const CustomOverlayPanel = (props: any) => {
  const { reference, children, showCloseIcon = false, ...rest } = props

  return (
    <OverlayPanel ref={reference} showCloseIcon={showCloseIcon} {...rest}>
      <div>
        <div className={classes['card']}>{children}</div>
      </div>
    </OverlayPanel>
  )
}

export default CustomOverlayPanel
